import React from 'react'
import Skeleton from 'react-loading-skeleton'

const EventLoader = () => {
  return (
    <div className="team_battles">
    <Skeleton
      // width={1200}
      height={150}
      count={1}
      style={{
        "--base-color": "#ccc",
        "--highlight-color": "#f5f5f5",
      }}
      inline
    />
  </div>
  )
}

export default EventLoader
